<dspx-card-set-base-form [formServiceEndpoint]="formServiceEndpoint"
                         [fieldTypeReplacements]="fieldTypeReplacements"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         [entityId]="id"
                         formName="VPTAS Application Details"
                         (onButtonClick)="buttonClicked($event)"
                         (onActionButtonClick)="handleActionButtonClick($event)"
                         (onDialogSubmit)="handleDialogButtonClick($event, activeDialog)"
                         (onFilter)="filter($event)"
                         (onFormLoad)="formLoaded($event)"
                         (onModelChange)="modelChanged($event)"
                         (onSave)="save($event)"
                         (onCancel)="cancel($event)">
</dspx-card-set-base-form>
